<template>
  <div class="page">
    <div class="breadcrumb">
      <router-link to="/home">上海盛目实业集团有限公司</router-link>
      <span>></span>
      <router-link to="/news">新闻中心</router-link>
      <!-- <span>></span>
      <span>{{newInfo.journalismTitle}}</span> -->
    </div>
    <!-- <div class="title">
      <p><strong>{{newInfo.journalismTitle}}</strong></p>
    </div> -->
    <div class="content-h" v-html="newInfo.journalismContent"></div>
  </div>
</template>

<script>
import { newInfo } from '@/api/api'
export default {
  data() {
    return {
      newInfo: {}
    }
  },
  created() {
    newInfo({
      id: this.$route.query.id
    }).then(res => {
      this.newInfo = res
      console.log(res)
    })
  }
}
</script>

<style lang="scss" scoped>
$page-center: 1200px;
.page {
  width: $page-center;
  margin: auto;
  padding-bottom: 50px;
  img {
    max-width: 100%;
  }
  .breadcrumb {
    margin: 30px auto 40px;
  }
  .title {
    color: #1c3c8a;
    font-size: 30px;
    text-align: center;
    margin-bottom: 40px;
  }
}
</style>
